<!-- (1.1.16) セグメント情報 (1) -->
<div
  [ngClass]="['p-flight-detail01__block', this.flight.statusCode === 'UN' ? 'p-flight-detail01__block--gray10' : '']"
>
  <!-- (1.1.18) 出発地までの経路案内 -->
  <div *ngIf="isRouteDeparture()" class="p-flight-detail01__item p-flight-detail01__item--route-top">
    <div class="p-flight-detail01__line p-flight-detail01__line--route-top"></div>
    <div class="p-flight-detail01__route">
      <div class="p-flight-detail01__route-item">
        <span class="p-flight-detail01__route-stamp">
          <a
            id="{{ id }}_guidance-to-departure"
            href="javascript:void(0)"
            (click)="clickGuidanceToDeparture(flight.id)"
          >
            <!-- 以下条件すべてを満たす場合、自宅等の出発地からまでの経路案内のリンクを表示する。-->
            {{ 'message.routeGuidance.departure' | staticMsg }}
            <img
              class="c-text-link-external"
              src="{{ appConstants.IMG.S01_P030_S01_U__ANOTHER_WINDOW }}"
              width="16"
              height="16"
              [alt]="'alt.anotherWindow' | staticMsg"
            />
          </a>
        </span>
      </div>
    </div>
  </div>
  <asw-departure [boundIdx]="boundIdx" [flightIdx]="flightIdx"></asw-departure>
  <asw-waiting [boundIdx]="boundIdx" [flightIdx]="flightIdx"></asw-waiting>
  <asw-arrival [boundIdx]="boundIdx" [flightIdx]="flightIdx" [isRouteArrival]="isRouteArrival()"></asw-arrival>
  <!-- (1.1.57) 到着地からの経路案内 -->
  <div *ngIf="isRouteArrival()" class="p-flight-detail01__item p-flight-detail01__item--route-bottom">
    <div class="p-flight-detail01__line p-flight-detail01__line--route-bottom"></div>
    <div class="p-flight-detail01__route">
      <div class="p-flight-detail01__route-item">
        <span class="p-flight-detail01__route-stamp">
          <a
            id="{{ id }}_guidance-to-destination"
            href="javascript:void(0)"
            (click)="clickGuidanceToDestination(flight.id)"
          >
            <!-- 以下の条件すべてを満たす場合、到着空港から自宅等の帰着地までの経路案内のリンクを表示する。-->
            {{ 'message.routeGuidance.arrival' | staticMsg }}
            <img
              class="c-text-link-external"
              src="{{ appConstants.IMG.S01_P030_S01_U__ANOTHER_WINDOW }}"
              width="16"
              height="16"
              [alt]="'alt.anotherWindow' | staticMsg"
            />
          </a>
        </span>
      </div>
    </div>
  </div>
</div>
